import '../style.scss';
import template from './subscriptionPriceFinderModal.html';
import controller from '../subscriptionModalCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
    subscriptionData: '<',
    orderedById: '<',
  },
};
